import type { ClientArgs, ClientInferResponseBody } from '@ts-rest/core';
import type { UseQueryOptions } from '@ts-rest/react-query/v5';

import type { LanguagesContract } from '@packages/contracts';

import { LANGUAGE_QUERY_KEY } from '../query-keys';

type LanguageListRoute = typeof LanguagesContract['list'];
type LanguageListResponse = ClientInferResponseBody<LanguageListRoute, 200>['result']['languages'];

export type LanguageListQueryOptions = UseQueryOptions<
	LanguageListRoute,
	ClientArgs,
	LanguageListResponse
>;

export const createLanguageListQueryOptions = (): LanguageListQueryOptions => ({
	queryKey: LANGUAGE_QUERY_KEY.list,

	retry: (failureCount, error) => {
		if ('statusCode' in error && (error.statusCode === 404 || error.statusCode === 400)) return false;

		return failureCount < 3;
	},
	select: res => res.body.result.languages,
});
